"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : TOASTER : STYLES --------------- ++++++++++ */


var _default = {
  toaster: {
    display: 'flex',
    alignItems: 'center',
    // 'flex-start'
    justifyContent: 'space-between',
    width: (0, _index.pxToEm)(400),
    borderRadius: (0, _index.pxToEm)(6),
    fontSize: (0, _index.pxToEm)(16),
    margin: (0, _index.replacePXinStringWithEM)("5px 15px"),
    padding: "".concat((0, _index.pxToEm)(20), " ").concat((0, _index.pxToEm)(18)),
    position: 'relative',
    // animation
    transition: 'filter .2s linear 0s',
    opacity: '0',
    animationDelay: '0s',
    animationDuration: '.15s',
    animationFillMode: 'forwards',
    // hover
    '&:hover': {
      filter: 'brightness(97%)'
    },
    // ----- alignment ----- //
    '&.align-top-left': {
      boxShadow: _index.theme.boxShadow.small,
      marginTop: (0, _index.pxToEm)(10),
      animationName: 'fadeInDown',
      justifySelf: 'flex-start',
      alignSelf: 'flex-start'
    },
    '&.align-top-right': {
      boxShadow: _index.theme.boxShadow.small,
      marginTop: (0, _index.pxToEm)(10),
      animationName: 'fadeInDown',
      justifySelf: 'flex-end',
      alignSelf: 'flex-end'
    },
    '&.align-bottom-left': {
      boxShadow: _index.theme.boxShadow.smallTop,
      marginBottom: (0, _index.pxToEm)(10),
      animationName: 'fadeInUp',
      justifySelf: 'flex-start',
      alignSelf: 'flex-start'
    },
    '&.align-bottom-right': {
      boxShadow: _index.theme.boxShadow.smallTop,
      marginBottom: (0, _index.pxToEm)(10),
      animationName: 'fadeInUp',
      justifySelf: 'flex-end',
      alignSelf: 'flex-end'
    },
    // ----- variants ----- //
    '&.variant-primary': {
      background: _index.theme.color.primary.medium.swatch,
      color: _index.theme.color.primary.medium.contrast
    },
    '&.variant-attention': {
      background: _index.theme.color.attention.medium.swatch,
      color: _index.theme.color.attention.medium.contrast
    },
    '&.variant-warning': {
      background: _index.theme.color.warning.medium.swatch,
      color: _index.theme.color.warning.medium.contrast
    },
    // ----- details ----- //
    '& .details': {
      display: 'flex',
      alignItems: 'center' //'flex-start'

    },
    // ----- icon ----- //
    '& .message-icon': {
      marginRight: (0, _index.pxToEm)(8)
    },
    // ----- title ----- //
    '& .title': {
      marginRight: (0, _index.pxToEm)(5)
    },
    // ----- close ----- //
    '& .close': {
      cursor: 'pointer',
      marginLeft: (0, _index.pxToEm)(15),
      transition: 'transform .15s linear 0s',
      '&:hover': {
        transform: 'scale(1.5)'
      }
    },
    // ---- custom fontsize for massive request demo message ----- //
    '& .pageview': {
      fontSize: (0, _index.pxToEm)(12)
    }
  }
};
exports.default = _default;